/**
 * @generated SignedSource<<c8c0ea352ccccba08911f01ffd27d8a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddIncludeOptInDispatchConditionInput = {
  clientMutationId?: string | null;
  messageDispatchId: string;
  optIn: boolean;
};
export type useDispatchConditions_AddIncludeOptInDispatchConditionMutation$variables = {
  input: AddIncludeOptInDispatchConditionInput;
};
export type useDispatchConditions_AddIncludeOptInDispatchConditionMutation$data = {
  readonly Admin: {
    readonly Message: {
      readonly addIncludeOptInDispatchCondition: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type useDispatchConditions_AddIncludeOptInDispatchConditionMutation = {
  response: useDispatchConditions_AddIncludeOptInDispatchConditionMutation$data;
  variables: useDispatchConditions_AddIncludeOptInDispatchConditionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Message",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "AddIncludeOptInDispatchConditionPayload",
            "kind": "LinkedField",
            "name": "addIncludeOptInDispatchCondition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDispatchConditions_AddIncludeOptInDispatchConditionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDispatchConditions_AddIncludeOptInDispatchConditionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "17542de4bf8f9e8603ccd4599d97594c",
    "id": null,
    "metadata": {},
    "name": "useDispatchConditions_AddIncludeOptInDispatchConditionMutation",
    "operationKind": "mutation",
    "text": "mutation useDispatchConditions_AddIncludeOptInDispatchConditionMutation(\n  $input: AddIncludeOptInDispatchConditionInput!\n) {\n  Admin {\n    Message {\n      addIncludeOptInDispatchCondition(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d61f0d25e5c130e8ad0d6865df8e7608";

export default node;
